import "./Loader.css";

const Loader = () => {
  return (
    <div className="loaderWrapper">
      <div className="spinnerDiv"></div>
      {/* <h1>Fetching Data</h1> */}
    </div>
  );
};

export default Loader;
